import { Component, EventEmitter, Input, Output } from '@angular/core';
import { showArticle } from '@intercom/messenger-js-sdk';
import { Icons } from 'src/app/types/icons';

@Component({
  selector: 'app-layout-dialog',
  templateUrl: './layout-dialog.component.html',
  styleUrls: ['./layout-dialog.component.scss'],
  standalone: false,
})
export class LayoutDialogComponent {
  @Input() dialogTitle: string = 'Title';
  @Input() showBreadcrumb: boolean = true;
  @Input() showFooter: boolean = true;
  @Input() learnId: string = '';

  @Output() closeDialog = new EventEmitter();

  Icons = Icons;

  openLearnArticle() {
    showArticle(this.learnId);
  }
}
